"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAttachDetails = void 0;
/** Парсит айди аттача и айди письма из пути */
var parseAttachDetails = function (attachPath, attachPathReg, emlFormatId) {
    var _a;
    var result = attachPath.match(attachPathReg);
    if (!result) {
        return null;
    }
    var _ = result[0], messageId = result[1], encodedAttachId = result[2];
    var _b = (_a = encodedAttachId.match(new RegExp(emlFormatId))) !== null && _a !== void 0 ? _a : [], emlId = _b[1], attachId = _b[2];
    var isEml = attachId && emlId;
    return {
        messageId: isEml ? "".concat(messageId, ";").concat(emlId) : messageId,
        encodedAttachId: isEml ? attachId : encodedAttachId,
    };
};
exports.parseAttachDetails = parseAttachDetails;
//# sourceMappingURL=parseAttachDetails.js.map